

















import Vue from 'vue'
import style from './style.module.scss'

import textInput from './input.vue'

export default Vue.extend({
    name: 'cell',
    components: {
        textInput
    },
    props: {
        data: [Number, String],
        isChecked: Boolean
    },
    data() {
        return {
            style: style,
            showInput: false,
            inputValue: this.data
        }
    },
    methods: {
        apply() {
            this.showInput = false;
            this.$emit('apply', this.inputValue);
        },
        input(data: string) {

            this.inputValue = data;

            if(!this.inputValue) {
                this.$emit('update', null);
                return
            }

            const intValue: number | null = parseFloat(data);
            this.$emit('update', intValue);
        },
        showAndFocusInput(): void {
           
            if (this.isChecked) {
                this.showInput = true;
                this.$nextTick(() => {
                    const input = this.$refs.input as Vue

                    if(input.$el instanceof HTMLElement) {
                        input.$el.focus()
                    }
                })
            }
        }
    },
    watch: {
        data(value) {
            this.inputValue = value || value === 0 ? value.toString() : ''
        }
    }
})
